import {
  Button,
  createTableColumn,
  makeStyles,
  SearchBox,
  Spinner,
  TableColumnDefinition,
} from "@fluentui/react-components";
import { useMemo, useState } from "react";
import { ClientRoutes } from "../../models/ClientRoutes";
import { useNavigate } from "react-router-dom";
import { Chapter } from "../../models/Chapter";
import { searchChapters } from "../../services/ChapterService";
import { useChaptersGetAll } from "../../hooks/useChapter";
import { useTranslation } from "react-i18next";
import GenericDataGrid from "../list/GenericDataGrid";
import {
  ChapterTitleColumn,
  VsaTableColumnDefinition,
} from "../../constants/DataGridColumns";

const useStyles = makeStyles({
  searchInput: {
    width: "300px",
  },
  editMetadataBtn: {
    marginTop: "20px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    height: "35px",
    marginBottom: "20px",
  },
  rightActions: {
    display: "flex",
  },
  leftActions: {
    display: "flex",
    gap: "20px",
  },
});

export const ChapterList = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: chapters, isLoading: activitiesLoading } = useChaptersGetAll();

  const [query, setQuery] = useState<string>("");
  const currentChapters = useMemo<Chapter[]>(() => {
    if (!chapters || activitiesLoading) {
      return [];
    }

    if (!query) {
      return chapters;
    }

    const foundActivities = searchChapters(query, chapters);

    return foundActivities;
  }, [query, chapters, activitiesLoading]);

  const columns: VsaTableColumnDefinition<Chapter>[] = [
    createTableColumn<Chapter>(
      ChapterTitleColumn as TableColumnDefinition<Chapter>
    ),
  ];

  return !activitiesLoading ? (
    <div>
      <div className={classes.header}>
        <div className={classes.leftActions}>
          <Button
            appearance="primary"
            onClick={() => navigate(ClientRoutes.CreateChapter)}
          >
            {t("createChapter")}
          </Button>
        </div>
        <div className={classes.rightActions}>
          <SearchBox
            className={classes.searchInput}
            placeholder={t("searchChapter")}
            value={query}
            onChange={(_ev, data) => setQuery(data.value)}
          />
        </div>
      </div>
      <GenericDataGrid<Chapter>
        items={currentChapters}
        getRowId={(chapter) => chapter.id}
        columns={columns}
      />
    </div>
  ) : (
    <Spinner />
  );
};
